<template>
  <el-main :style="{height:height+'px'}" >
    <div class="Scroll_content">
      <div id="lessons">

        <div v-if="lessonData.length != 0">

          <div v-for="(item,index) in lessonData" :key="index">
            <div class="title_older">{{item.title}}</div>
              <div class="list_content" v-for="(items,index) in item.list" :key="index">
              <div class="left_content">
                <div class="time_text">
                  <div class="title_content">{{items.subject_title}}</div> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <div class="timecontent">
                    {{items.start_time}} - {{items.end_time}}
                  </div>
                </div>
              </div>
              <div class="content_box">

                <div class="title_content_bom">
                  <div class="dom">
                    <p>{{$t('new_test3.Level')}}</p> :&nbsp;&nbsp;<span>{{items.level_title}}</span></div>
                  <div class="dom">
                    <p>{{$t('new_test3.Topic')}}</p> :&nbsp;&nbsp;<span>{{items.lesson_topic?items.lesson_topic:'-'}}</span></div>
                </div>
                <div class="send_botton">
                  <div class="sinder_bun" style="display: flex;flex-direction: row;">

                    <div class="bunmerr" @click="openComments(items.comments_teacher_id)" v-if="items.comments_teacher_status" style="margin-right: 24px;">{{$t('main.teacherComments')}}</div>
                    <div class="bunmerr" @click="viewFee(items.comments_id)" v-if="items.comments_status">{{$t('main.viewFeedback')}}</div>
                    <div class="bunmer" @click="leaveFee(items)" v-else>{{$t('main.leaveFeeback')}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>


        <NoScheduleEmpty v-else />

      <div class="dian"></div>
      </div>


    <div v-if="isShowLeave" class="el-message-box__wrapper" style="z-index: 2010;background:rgb(0 0 0 / 30%)">
      <div class="el-message-box">
        <div class="el-message-box__header">
          <div class="el-message-box__title center">
            <b>{{$t('main.leaveFeeback')}}</b>
          </div>
          <button type="button" class="el-message-box__headerbtn" @click="chooseImg">
            <i class="el-message-box__close el-icon-close"></i>
          </button>
        </div>
        <div class="el-message-box__content">
          <div class="el-message-box__container">
            <div class="el-message-box__message" style="display: flex;flex-direction: row">
              <p style="margin-top: 8px;">{{$t('main.rating')}}</p>
              <div class="starList">
                <el-rate v-model="LeaveScore"
                :allow-half="true"
                void-color="#B50604"
                ></el-rate>

              </div>


            </div>
          </div>
        </div>
        <div class="el-message-box__btns">
          <button style="background: #B50604 !important;border-color: #B50604 !important;" type="button" class="el-button el-button--default el-button--small el-button--primary" @click="submitSick">
            <span>{{$t('main.send')}}</span>
          </button>
        </div>
      </div>
    </div>

    <div v-if="isShowView" class="el-message-box__wrapper" style="z-index: 2010;background:rgb(0 0 0 / 30%)">
      <div class="el-message-box">
        <div class="el-message-box__header">
          <div class="el-message-box__title center">
            <b>{{$t('main.leaveFeeback')}}</b>
          </div>
          <button type="button" class="el-message-box__headerbtn" @click="chooseview">
            <i class="el-message-box__close el-icon-close"></i>
          </button>
        </div>
        <div class="el-message-box__content">
          <div class="el-message-box__container">
            <div class="el-message-box__message" style="display: flex;flex-direction: row">
              <p style="margin-top: 8px;">{{$t('main.rating')}}</p>
              <div class="starList">
                <el-rate
                  v-model="viewData.rating" :allow-half="true"
                  :disabled="true" :colors="['#B50604', '#B50604', '#B50604']"
                disabled-void-icon-class="none_icon">
                </el-rate>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isShowComment" class="el-message-box__wrapper" style="z-index: 2010;background:rgb(0 0 0 / 30%)">
      <div class="commentbox el-message-box">
        <div style="display: flex;justify-content: space-between;align-items: center;">
          <span style="color: #333333;font-size: 16px;font-weight: 500;">{{ $t('main.teacherComments') }}</span>
          <span style="font-size: 24px;color: #BDBDBD;cursor: pointer;" @click="isShowComment = false"><i class="el-icon-close"></i></span>
        </div>

        <div style="display: flex;align-items: center;margin: 12px 0;">
          <img style="width: 36px;height: 36px;border-radius: 18px;" :src="commentobj.teacher_avatar" alt="">
          <p style="margin-left: 12px;">{{commentobj.teacher_alias}}</p>
        </div>

        <hr style="border: 0;background-color: #D4D4D4;height: 1px;">

        <div style="margin-top: 12px;color: #FF6E17;font-size: 16px;word-break: break-all;max-height: 400px;overflow-y: auto;padding-bottom: 20px">
          {{ commentobj.comment }}
        </div>
      </div>
    </div>


    </div>
  </el-main>

</template>
<script>
  import { setStore, getStore, keys } from '@/store';
  import IndexFooter from '../views/footer'
  import MyScheduled from '../views/scheduled'
  import MyCourse from '../views/course'
  import PastLesson from '../views/lesson'

  //引入header组件
  import Header from '../header/header'
  import NoScheduleEmpty from './NoScheduleEmpty'

  export default {
    components: {
      IndexFooter,
      MyScheduled,
      PastLesson,
      MyCourse,
      Header,
      NoScheduleEmpty
    },
    data () {
      return {
        searchStudentSn:"",
        height:100,
        lessonData:[],
        pagesize:'',
        page:'',


        lessondata: {},
        addComment: '',
        isShowLeave: false,
        isShowView: false,
        viewData: {},
        LeaveScore: 0, // 评分星星级别
        clickNum: 1,
        scoreArray: [1, 2, 3, 4, 5], // 分为1-5个评分层次
        commentobj:{}, // 教师点评
        isShowComment: false, // 查看评论
      }
    },
    created () {
      let height = document.body.offsetHeight-104;
      this.height = height
      // console.log(1111,height);
      if (getStore(keys.token)) {
        if (getStore(keys.userInfo).status == 0) {
          this.$router.push({
            path: '/onboarding'
          })
        }
      } else {
        this.$router.push({
          path: '/'
        })
        return false
      }
      this.getLesson();
      if (this.$route.query.type == 1) {
        this.activeTitle = 'course'
      } else {
        this.activeTitle = 'schedule'
      }
    },
    methods: {
      /**
       * 教师点评
       */
      openComments (teacher_id) {
        // children_id.last_student_sn
        this.$http.get('/api/getTutorReply?comment_id=' + teacher_id).then((res) => {
          if (res.data.code == 200) {
            // console.log(999,res);
            this.isShowComment = !this.isShowComment
            this.commentobj = res.data.data
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },
      /**
       * 获取已完成课程
       */
      getLesson () {
        let children_id = getStore(keys.userProfile);
        // children_id.last_student_sn
        this.$http.get('/api/getClosedSectionWeb?student_sn=' + children_id.last_student_sn + '&time_diff=' + this.utils.timeZone()+'&pagesize='+this.pagesize+'&page='+this.page).then((res) => {
          if (res.data.code == 200) {
            // console.log(999,res);
            let arr = res.data.data;

            for(var i=0;i<arr.length;i++){
              arr[i].list = [];
              arr[i].list.push(arr[i].data);
            }

            // console.log(arr);


            this.lessonData = arr;
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },

      /**
       * 原始代码复制模块
       */
          leaveFee (item) {
            this.lessondata = item
            this.isShowLeave = !this.isShowLeave
            this.LeaveScore = 0
          },
          viewFee (comments_id) {
            this.$http.get('/api/getReply?comment_id=' + comments_id).then((res) => {
              if (res.data.code == 200) {
                console.log(res)
                this.isShowView = !this.isShowView
                this.viewData = res.data.data
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'warning'
                })
              }
            }).catch((error) => {
              console.log(error) // 请求失败返回的数据
            })
          },
          chooseview () {
            this.isShowView = !this.isShowView
          },
          chooseImg () {
            this.isShowLeave = !this.isShowLeave
          },
          submitSick () {
            if (this.LeaveScore == 0) {
              this.$message({
                message: 'Please give feedback',
                type: 'warning'
              })
              return false
            }
            this.$http.post('/api/saveReply', {
              lesson_sn: this.lessondata.lesson_sn,
              student_sn: this.lessondata.student_sn,
              comment: this.addComment,
              rating: this.LeaveScore
            }).then((res) => {
              if (res.data.code == 200) {
                console.log(res)
                this.isShowLeave = !this.isShowLeave
                this.$notify({
                  message: this.$t('main.sendSuccess')
                })
                this.getLesson()
                // this.datalesson.map((item) => {
                //   if (item.lesson_sn == this.lessondata.lesson_sn && item.student_sn == this.lessondata.student_sn && res.data.status) {
                //     item.comments_status = true
                //   }
                // })
                // this.$forceUpdate()
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'warning'
                })
              }
            }).catch((error) => {
              console.log(error) // 请求失败返回的数据
            })
          },
          getLessonn () {
            let searchChild = getStore(keys.searchFilter)
            this.$http.get('/api/finishSectionWeb?student_sn=' + searchChild + '&time_diff=' + this.utils.timeZone()).then((res) => {
              if (res.data.code == 200) {
                console.log(res)
                this.datalesson = res.data.data
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'warning'
                })
              }
            }).catch((error) => {
              console.log(error) // 请求失败返回的数据
            })
          }
    },
    mounted () {
      // window.onresize = () => {
      //   let height = document.body.offsetHeight-83;
      //   this.height = height
      //   console.log(1111,height);
      // }
    },
  }
</script>
<style lang="less" scoped>
.el-main {
  overflow: inherit;
}

.Scroll_content {
  height: 400px;

  .list_content {
    background: #FFFFFF;
    border: 1px solid rgba(0, 0, 0, 0.09);
    box-shadow: 0px 4px 26.64px rgba(0, 0, 0, 0.09);
    border-radius: 9px;
    box-sizing: border-box;
    margin-top: 17px;

    .left_content {
      font-family: Sofia Pro;
      font-style: normal;
      display: flex;
      justify-content: space-between;

      .time_text {
        font-size: 20px;
        margin: 16px 0 10px 16px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        flex: 1;

        .title_content {
          font-family: Sofia Pro;
          font-style: normal;
          font-weight: 500;
          font-size: 20px;
          color: #000000;
          margin-bottom: 0;
        }

        .timecontent {
          display: flex;
          align-items: center;
          font-size: 16px;
          color: #6B6B6B;

          button {
            margin-left: 30px;
          }
        }
      }
    }

    .content_box {
      border: 0px solid red;
      margin: 0px 16px 16px 16px;
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .title_content_bom {
        display: flex;

        .dom {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;

          p {
            font-size: 16px;
            color: #000000;
            min-width: 40px;
          }

          span {
            font-size: 16px;
            color: #6B6B6B;
            display: block;
            min-width: 162px;
            margin-top: 0;
          }
        }
      }

      .send_botton {
        display: flex;
        margin-left: 30px;
        min-width: 100px;
        .bunmer {
          background: #B50604;
          border-radius: 8px;
          font-family: Sofia Pro;
          font-style: normal;
          font-size: 16px;
          line-height: 16px;
          align-items: center;
          text-align: center;
          color: #FFFFFF;
          margin-top: 16px;
          cursor: pointer;
          padding: 10px 16px;
          box-sizing: border-box;
        }
      }
    }
  }
}

.title_older {
  font-family: Sofia Pro;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 24px;
  color: #000000;
  margin-top: 18px;
}

.el-message-box__title {
  font-family: Sofia Pro !important;
  font-style: normal !important;
  font-weight: 600 !important;
  font-size: 24px !important;
  line-height: 37px !important;
  text-align: center !important;
  color: #000000 !important;
}

.bunmerr {
  background-color: #fff;
  border: 2px solid #b50604;
  border-radius: 8px;
  font-family: Sofia Pro;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 16px;
  align-items: center;
  text-align: center;
  color: #b50604;
  margin-top: 16px;
  cursor: pointer;
  padding: 10px 16px;
  box-sizing: border-box;
  height: 36px;
}

.el-message-box {
  background: #ffffff !important;
}

.el-message-box__message p {
  font-family: Sofia Pro;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 25px;
  color: #000000;
}

/deep/ .el-rate {
  height: 50px;

  .el-rate__icon {
    font-size: 35px;
    color: #b50604 !important;
  }

  .el-rate__icon.hover {
    transform: scale(1);
  }

  .el-icon-star-on:before {
    content: url("../../assets/ant-design_star-filled.svg")
  }

  .none_icon:before,
  .el-icon-star-off:before {
    content: url("../../assets/ant-design_star-outlined.svg")
  }
}

.starList {
  margin-left: 34px;
  margin-top: 5px;
  margin-bottom: 34.1px;
}

.el-message-box__message textarea {
  height: 90px !important;
  border: 1px solid #F2F2F2 !important;
  font-family: Sofia Pro !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-size: 16px !important;
  line-height: 16px !important;
  color: #A5A5A5 !important;
}

.el-message-box__btns button {
  width: 311px !important;
  height: 60px !important;
  background: #B50604 !important;
  border-radius: 50px !important;
  font-family: Sofia Pro !important;
  font-style: normal !important;
  font-weight: bold !important;
  font-size: 18px !important;
  line-height: 18px !important;
  border: 1px solid #B50604 !important;
  align-items: center !important;
  text-align: center !important;
  letter-spacing: -0.01em !important;
  margin: 0 auto 0 auto;
  color: #FFFFFF !important;
}

.pl {
  margin-left: 14px;
  margin-top: 10px;
  font-family: Sofia Pro !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-size: 16px !important;
  line-height: 16px !important;
  color: #000000 !important;
  margin-bottom: 20px;
}

.commentbox {
  width: 500px;
  background: #FFFAE5 !important;
  border-radius: 16px;
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/children/ViewCompletedLessons.vue